<template>
    <ies-form-field :field="field">
        <div class="d-flex flex-column">
            <input type="hidden" :name="field.fieldName" :value="field.value">
            <v-row v-for="phone in telephoneNumbers">
                <h4>{{ phone.phone_number }}</h4>
            </v-row>
            <v-text-field hide-details
                label="Test"
                :name="this.field.fieldName"
                :disabled="this.field.disabled"
            ></v-text-field>
        </div>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-input-telephone-numbers',
    props: ['field', 'recordData'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
			telephoneNumbers: [],
        }
    },
	created: function() {
		this.getTelephoneNumbers();
	},
	methods: {
		getTelephoneNumbers() {
			axios.get('/api/telephone-numbers/' + this.recordData.hotel_key, {
				params: {}
			}).then(function(response) {
				var allPhones = response.data.phones; 
				if ( this.field.schema.displayName === "Telephone" ) {
					this.telephoneNumbers = allPhones.filter((phone) => { return phone.is_telephone });
				} else if ( this.field.schema.displayName === "Fax" ) {
					this.telephoneNumbers = allPhones.filter((phone) => { return phone.is_fax });
				}
				console.log(this.telephoneNumbers);
			}.bind(this));
		},
	},
	watch: {
		telephoneNumbers: function (newValue) {
			console.log(newValue);
		}
	}	
}
</script>

